// import TestVid from "../../public/hero-section-video.mp4"
const StackData = [
  {
    "title": "Team Building and Collaboration",
    // "vid": TestVid,
    "description": "Unify teams with customized training sessions aimed at enhancing trust, communication, and collaboration. Dr.Bhupendra helps teams unlock:",
    "keyPoints": [
      "Deeper Interpersonal Connections",
      "Higher Responsiveness to Challenges",
      "Improved Team Communication"
    ]
  },
  {
    "title": "Leadership Development",
    // "vid": TestVid,
    "description": "Empower emerging leaders with tools and insights to guide their teams more effectively.",
    "keyPoints": [
      "Boosted Decision-Making Skills",
      "Enhanced Conflict Resolution",
      "Greater Emotional Intelligence"
    ]
  },
  {
    "title": "Change Management",
    // "vid": TestVid,
    "description": "Support your team through organizational changes with resilience-building workshops.",
    "keyPoints": [
      "Improved Adaptability",
      "Stronger Team Alignment",
      "Clearer Communication During Change"
    ]
  },
  {
    "title": "Conflict Resolution Training",
    // "vid": TestVid,
    "description": "Equip your team with techniques to manage and resolve conflicts constructively.",
    "keyPoints": [
      "Reduced Workplace Tension",
      "Improved Listening Skills",
      "Faster Conflict Recovery"
    ]
  },
  {
    "title": "Innovation and Creativity Workshops",
    // "vid": TestVid,
    "description": "Foster a culture of innovation by helping teams think creatively and work collaboratively.",
    "keyPoints": [
      "Enhanced Problem-Solving Skills",
      "Encouragement of Creative Risk-Taking",
      "Collaborative Idea Generation"
    ]
  }
]

export default StackData